import { CoreEffects } from './core.effects';
import { UserTenanciesEffects } from './userTenancies.effects';
export const EFFECTS = [UserTenanciesEffects, CoreEffects]